import { devModeConfig } from "../../app/components/DevMode.helpers";
import { devConstants as constants } from "../constants";
import * as immutable from 'object-path-immutable'
import { addFileInFolder, deleteElement, getSavedState, newItem, prepareItem, searchElementData, setExpandedFolders, updateData, updateDataOpenFiles } from "./dev.reducer.helper";
import { flattenTree } from "react-accessible-treeview";
const defaultState = getSavedState();

const reducersObject = {
  [constants.GET_TEMPLATES.REQUEST]: (state, payload) => {
    return {
      ...state,
      isFetching: true, 
    };
  },
  [constants.GET_TEMPLATES.SUCCESS]: (state, payload) => {
    return {
      ...state,
      templates: payload?.value.map(item => prepareItem(item, devModeConfig.template.type, devModeConfig.template.controllerName)),
      isFetching: false, 
    };
  },
  [constants.GET_TEMPLATES.FAILURE]: (state, payload) => {
    return {
      ...state,
      isFetching: false, 
    }; 
  },
  [constants.GET_PRIMITIVAS.REQUEST]: (state, payload) => {
    return {
      ...state,
      isFetching: true, 
    };
  },
  [constants.GET_PRIMITIVAS.SUCCESS]: (state, payload) => {
    return {
      ...state,
      primitivas: payload?.value.map(item => prepareItem(item, devModeConfig.primitiva.type, devModeConfig.primitiva.controllerName)),
      isFetching: false, 
    };
  },
  [constants.GET_PRIMITIVAS.FAILURE]: (state, payload) => {
    return {
      ...state,
      isFetching: false, 
    }; 
  },
  [constants.GET_OPERACIONES.REQUEST]: (state, payload) => {
    return {
      ...state,
      isFetching: true, 
    };
  },
  [constants.GET_OPERACIONES.SUCCESS]: (state, payload) => {
    //payload.list.map(item => item._elementId ? item : {...item, _elementId: `${item.id}-${payload.type}`, _type: payload.type });
    return {
      ...state,
      operaciones: payload?.value.map(item => prepareItem(item, devModeConfig.operacion.type, devModeConfig.operacion.controllerName)),
      isFetching: false, 
    };
  },
  [constants.GET_OPERACIONES.FAILURE]: (state, payload) => {
    return {
      ...state,
      isFetching: false, 
    }; 
  },
  [constants.GET_CONNECTION_TYPES.REQUEST]: (state = defaultState, payload) => {
    return {
      ...state,
      isFetching: true, 
    };
  },
  [constants.GET_CONNECTION_TYPES.SUCCESS]: (state = defaultState, payload) => {
    return {
      ...state,
      operationsEditor:{
        ...state.operationsEditor,
        connectionTypes: payload.value
      },
      isFetching: false, 
    };
  },
  [constants.GET_CONNECTION_TYPES.FAILURE]: (state = defaultState, payload) => {
    return {
      ...state,
      isFetching: false, 
    }; 
  },
  [constants.GET_NODE_TYPES.REQUEST]: (state = defaultState, payload) => {
    return {
      ...state,
      isFetching: true, 
    };
  },
  [constants.GET_NODE_TYPES.SUCCESS]: (state = defaultState, payload) => {
    return {
      ...state,
      operationsEditor:{
        ...state.operationsEditor,
        nodeTypes: payload.value
      },
      isFetching: false, 
    };
  },
  [constants.GET_NODE_TYPES.FAILURE]: (state = defaultState, payload) => {
    return {
      ...state,
      isFetching: false, 
    }; 
  },
  [constants.OPEN_TAB]: (state, payload) => {
    console.log("OPEN_TAB", {payload, state});
    const item = typeof payload.data === "object" 
    ? payload.data 
    : immutable.get(state.explorer.data, searchElementData(state.explorer.data, payload.data).path);
    const index = state.tabs.findIndex(tab => tab.data.id === item.id.replace("/open", ""));
    let newTabs;
    let newSelectedTab;
    if(index === -1){
      newTabs = [...state.tabs, {changed: false, data: item}];
      newSelectedTab = newTabs.length - 1;
    }else{
      newTabs = state.tabs;
      newSelectedTab = index;
    }
    return {
      ...state,
      tabs: newTabs,
      selectedTab: newSelectedTab
    }; 
  },  
  [constants.RELOAD_ITEM.SUCCESS]: (state, payload) => {
    const newTabs = state.tabs.map(tab => {
      return tab.data.id === `${payload.id}-${payload.type}` 
        ? {...tab,
            data: { 
              ...tab.data,
              data: payload.data,
            }
          }
        : tab; 
    });
    return {
      ...state,
      tabs: newTabs,
    };
  },  
  [constants.RELOAD_LOCAL_ITEM]: (state, payload) => {
    console.log({payload, tabs: state.tabs});
    const newTabs = state.tabs.map(tab => {
      return tab.data.id === `${payload.id}-${payload.type}` 
        ? {...tab,
            data: { 
              ...tab.data,
              data: payload.data,
            }
          }
        : tab; 
    });
    return {
      ...state,
      tabs: newTabs,
    };
  },
  [constants.OPEN_TAB2.SUCCESS]: (state, payload) => {
    const index = state.tabs.findIndex(tab => tab.data.id === payload.id);
    let newTabs;
    let newSelectedTab;
    if(index === -1){
      newTabs = [...state.tabs, {changed: false, data: payload}];
      newSelectedTab = newTabs.length - 1;
    }else{
      newTabs = state.tabs;
      newSelectedTab = index;
    }
    return {
      ...state,
      tabs: newTabs,
      selectedTab: newSelectedTab
    }; 
  },
  [constants.SELECT_TAB]: (state, payload) => {
    return {
      ...state,
      selectedTab: payload
    }; 
  },
  [constants.CLOSE_TAB]: (state = defaultState, payload) => {
    const closeTabIndex = state.tabs.findIndex(tab => tab.data.id === payload);
    const currentTab = state.tabs[state.selectedTab];
    const state1 = deleteElement(state, "tabs", tab => tab.data.id === payload);
    let selectedTab;
    if(state.selectedTab === closeTabIndex){
      selectedTab = state1.tabs[closeTabIndex] ? closeTabIndex : state1.tabs.length-1;
    }else{
      selectedTab = state1.tabs.findIndex(tab => tab.data.id === currentTab.data.id);
    }
    console.log({state1, state, payload, closeTabIndex, currentTab});
    return immutable.set(state1, "selectedTab", selectedTab); 
  },
  [constants.SET_CHANGED_TAB]: (state = defaultState, payload) => {
    const state1 = immutable.set(state, `tabs.${payload.index}.changed`, payload.value);
    return state1;
  },
  [constants.UPDATE_TAB_TEMPLATE]: (state = defaultState, payload) => {
    return immutable.set(state,`tabs.${payload.index}.data.data.value.template`, payload.code);
  },  
  [constants.UPDATE_TAB_ORQUESTADOR]: (state = defaultState, payload) => {
    return immutable.set(state,`tabs.${payload.index}.data.data.value.flowData`, payload.flowData);
  },
  [constants.UPDATE_TAB_DATA]: (state = defaultState, payload) => {
    const type = immutable.get(state,`tabs.${payload.index}.data.metadata.type`);
    const id = immutable.get(state,`tabs.${payload.index}.data.data.value.id`);
    const controller = devModeConfig[type].controllerName;
    const itemIndex = state[controller]?.findIndex(item => item.id === id);
    if(itemIndex === -1 || !id || !type) return state;
    const withUpdateListData = immutable.set(state, `${controller}.${itemIndex}`, prepareItem(payload.data.value, type, controller));
    const withUpdateTabData = immutable.set(withUpdateListData, `tabs.${payload.index}.data.data`, payload.data);
    const withUpdateTabName = immutable.set(withUpdateTabData, `tabs.${payload.index}.data.name`, payload.data.value.nombre);
    const withUpdateMetodo = immutable.set(withUpdateTabName, `tabs.${payload.index}.data.metadata.item.metodo`, payload.data.value.metodo);
    console.log("UPDATE_TAB_DATA", {state, updatedState: withUpdateMetodo, payload, itemIndex, id, type});
    return withUpdateMetodo;
  },
  [constants.UPDATE_TAB_PRIMITIVA]: (state = defaultState, payload) => {
    const newState = immutable.set(
      immutable.set(
        state,
        `tabs.${payload.index}.data.data.value.templateBodyJsonOutput`, payload.data.templateBodyJsonOutput
      ),
      `tabs.${payload.index}.data.data.value.templateBodyJson`, payload.data.templateBodyJson
    );
    return newState;    
  },  
  [constants.UPDATE_EXPLORER_DATA]: (state = defaultState, payload) => {
    const list = payload.list.map(item => item._elementId ? item : {...item, _elementId: `${item.id}-${payload.type}`, _type: payload.type });
    const data = updateData(state.explorer.data, payload.folder, list, payload.type);
    const treeData = flattenTree(data);
    return immutable.assign(state, "explorer", {data, treeData});
  },  
  [constants.UPDATE_EXPLORER_DATA_OPEN_FILES]: (state = defaultState, payload) => {
    const data = updateDataOpenFiles(state.explorer.data, state.tabs);
    const treeData = flattenTree(data);
    return immutable.assign(state, "explorer", {data, treeData});
  },
  [constants.CREATE_NEW_FILE]: (state = defaultState, payload) => {
    console.log("CREATE NEW FILE", {payload, state});

    const test1 = searchElementData(state.explorer.data, payload.folderElement.id);
    console.log("search item", test1);
    const fileTest = {
        "metadata": {
            "type": payload.type,
            "item": {
                "id": 0,
                "nombre": "",
            },
            "isNew": true
        },
        "name": "0-new-file",
        "id": `0-template`,
    };
    const data = addFileInFolder(state.explorer.data, payload.folderElement, fileTest)
    const treeData = flattenTree(data);
    const newState = immutable.assign(state, "explorer", {data, treeData});
    console.log("CREATE NEW FILE", {data, treeData, payload, state, newState});
    return newState;
  },
  [constants.CANCEL_NEW_FILE]: (state = defaultState, payload) => {
    console.log("CANCEL NEW FILE", {payload, state});
    const result = searchElementData(state.explorer.data, payload.id);
    if(!result) return state;
    const data = immutable.del(state.explorer.data, result.path);
    const treeData = flattenTree(data);
    return immutable.assign(state, "explorer", {data, treeData});
  },
  [constants.CONFIRM_NEW_FILE]: (state = defaultState, payload) => {
    const result = searchElementData(state.explorer.data, payload.id);
    if(!result) return state;
    const data = immutable.del(state.explorer.data, result.path);
    const treeData = flattenTree(data);
    const controller = devModeConfig[payload.type].controllerName;
    const state1 = immutable.insert(state, controller, prepareItem({...newItem[payload.type](payload), id: payload.newId}, payload.type, controller), 0);
    
    console.log("CONFIRM NEW FILE", {payload, state, state1, newId: payload.newId, data, treeData, result});
    return immutable.assign(
        state1, 
        "explorer", {data, treeData}
      );
  },
  [constants.SAVED_NEW_FILE]: (state = defaultState, payload) => {
    console.log("CONFIRM NEW FILE", {payload, state});
    const result = searchElementData(state.explorer.data, payload.id);
    if(!result) return state;
    const controller = devModeConfig[payload.type].controllerName;
    return immutable.insert(state, controller, newItem[payload.type](payload), 0);
  },  
  [constants.REMOVE_ITEM.SUCCESS]: (state = defaultState, payload) => {
    console.log("REMOVE ITEM SUCCESS", {payload, state});
    const controller = payload.element.metadata.item._controllerName; 

    
    const dataIndex = state[controller].findIndex(item => item._elementId = payload.element.id);
    const state1 = immutable.del(state, `${controller}.${dataIndex}`);

    const state2 = reducersObject[constants.CLOSE_TAB](state1, payload.element.id);

    const data = updateDataOpenFiles(state2.explorer.data, state2.tabs);
    const treeData = flattenTree(data);
    return immutable.assign(state2, "explorer", {data, treeData});

  },  
  [constants.SELECT_NODE_FILE]: (state = defaultState, payload) => {
    console.log("SELECT NODE FILE", {payload, state});
    const result = searchElementData(state.explorer.data, payload.id)
    const expandedIds = setExpandedFolders(result.foldersIds, true, state.explorer.expandedIds);
    return immutable.assign(state, "explorer", {selectedId: payload.id, expandedIds});
  },
  [constants.SET_EXPANDED_FOLDER]: (state = defaultState, payload) => {
    const ids = typeof payload.id === "string" ? [payload.id] : payload.id;
    const expandedIds = setExpandedFolders(ids, payload.expanded, state.explorer.expandedIds);
    const state1 = immutable.set(state, "explorer.expandedIds", expandedIds);
    console.log("SET EXPANDED FOLDER", {payload, state, state1});
    return state1;
  },
  [constants.POST_ADD_ITEM]: (state = defaultState, payload) => {
    console.log("POST ADD ITEM", {payload, state});
    const result = searchElementData(state.explorer.data, payload.id)
    const controller = devModeConfig[payload.type].controllerName;
    // eliminar el elemento en el explorador d eproyecto (data)
    const state1 = deleteElement(state, controller, item => item._elementId === payload.tab.data.id);
    // agregar el elemento nuevo a data
    const state2 = immutable.insert(state1, controller, prepareItem(payload.item, payload.type, controller));
    // cerrar el tab de ese elemento
    const state3 = deleteElement(state2, "tabs", tab => tab.data.id === payload.tab.data.id);
    return state3;
  },
  [constants.CHANGE_NAVIGATOR_URL]: (state = defaultState, payload) => {
    const state1 = immutable.set(state, "navigator.url", payload.value);
    localStorage.setItem("dev-navigator", JSON.stringify(state1.navigator));
    return state1;    
  },
  "default": (state, payload) => state
}  


export const devReducer = (state = defaultState, {type, payload}) => {
  const redu = reducersObject[type] || reducersObject.default;
  const newState = redu(state, payload);
  return newState;
}

